/**
 * CollabV3HostRow 컴포넌트
 * @description 주최 줄 — 48 얼굴과 `Hosted by 노바 광고팀`. 조직 명의는 사각, 개인은 원형(앱
 *   `CollabDetailHostRow`). 웹에서는 프로필로 넘기지 않는다 — 2.0 상세의 개설자 줄과 같다.
 * @example <CollabV3HostRow organizer={detail.organizer} />
 */
import { memo } from "react";

import CollabV3Avatar from "./CollabV3Avatar";
import { collabV3DetailStyles } from "./CollabV3Detail.styles";
import type { CollabV3HostRowProps } from "./CollabV3Detail.types";

import { COLLAB_V3_COPY } from "../../constants/collabV3Copy";

const CollabV3HostRow = memo<CollabV3HostRowProps>(({ organizer }) => {
  const styles = collabV3DetailStyles.host;
  return (
    <div className={styles.root}>
      <CollabV3Avatar person={organizer} size="sm" isSquare={organizer.isSquare} />
      <p className={styles.text}>
        {COLLAB_V3_COPY.host.label}{" "}
        <span className={styles.name}>{organizer.name}</span>
      </p>
    </div>
  );
});

CollabV3HostRow.displayName = "CollabV3HostRow";

export default CollabV3HostRow;
